import React from 'react';
import { ClockIcon, MailIcon, MapPinIcon, MessageCircleIcon, NavigationIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { business } from '../../data/site';
import { whatsappLink } from '../../utils/whatsapp';
export function ContactInfo() {
  const {
    t
  } = useLanguage();
  const info = t.contact.info;
  return <div className="flex h-full flex-col gap-6" data-id="element-272" data-mp="fqck5patxa0r">
      <div className="rounded-2xl border border-petal bg-white p-7" data-id="element-273" data-mp="fp1ipw4uwect">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#25D366]/10 px-3 py-1 text-xs font-medium text-[#0f7a3d]" data-id="element-274" data-mp="asb0b25kx6o8">
          <span className="h-1.5 w-1.5 rounded-full bg-[#25D366]" aria-hidden="true" data-id="element-275" data-mp="pfw0oob2krsg" />
          {info.online}
        </span>
        <ul className="mt-6 space-y-5" data-id="element-276" data-mp="kjox3265bsdo">
          <Row icon={PhoneIcon} label={info.phone} data-id="element-277" data-mp="ygc828uxoj2l">
            <a href={business.phoneHref} className="hover:text-mauve" data-id="element-278" data-mp="yerasbh8im11">
              {business.phoneIntl}
            </a>
          </Row>
          <Row icon={MessageCircleIcon} label={info.whatsapp} data-id="element-279" data-mp="38dui0fdzxnjh">
            <a href={whatsappLink()} target="_blank" rel="noreferrer" className="hover:text-mauve" data-id="element-280" data-mp="38fp2jslcvdn1">
              {info.whatsappValue}
            </a>
          </Row>
          <Row icon={MailIcon} label={info.email} data-id="element-281" data-mp="3i9xfh7xwky03">
            <a href={`mailto:${business.email}`} className="break-all hover:text-mauve" data-id="element-282" data-mp="3nabqmyuswo2c">
              {business.email}
            </a>
          </Row>
          <Row icon={ClockIcon} label={info.hours} data-id="element-283" data-mp="3rbnfv39rj7a0">
            {info.hoursLines.map(line => <span key={line} className="block" data-id="element-284" data-mp="4azurkm8zvo">
                {line}
              </span>)}
          </Row>
          <Row icon={MapPinIcon} label={info.area} data-id="element-285" data-mp="4yydtwhzubw0">
            {info.areaValue}
          </Row>
        </ul>
        <a href={business.directions} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-mauve hover:text-mauve-deep" data-id="element-286" data-mp="eus047liljqz">
          <NavigationIcon className="h-4 w-4" aria-hidden="true" data-id="element-287" data-mp="2fwhsjovpanqi" />
          {info.directions}
        </a>
      </div>

      <div className="min-h-[260px] flex-1 overflow-hidden rounded-2xl border border-petal" data-id="element-288" data-mp="2ayze5iywzgb4">
        <iframe title={info.mapTitle} src={business.mapEmbed} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-full min-h-[260px] w-full border-0" data-id="element-289" data-mp="2opl4fsqp6sj1" />
      </div>
    </div>;
}
function Row({
  icon: Icon,
  label,
  children
}: {
  icon: React.ComponentType<{
    className?: string;
  }>;
  label: string;
  children: React.ReactNode;
}) {
  return <li className="flex gap-4" data-id="element-290" data-mp="37nnl9k93dj5r">
      <Icon className="mt-0.5 h-5 w-5 shrink-0 text-mauve" aria-hidden="true" data-id="element-291" data-mp="37lukgll5tt5o" />
      <div className="min-w-0" data-id="element-292" data-mp="33ndhme8rv4u2">
        <p className="text-xs font-medium uppercase tracking-wider2 text-ink/50" data-id="element-293" data-mp="1d9wd6p6ev7cf">{label}</p>
        <p className="mt-1 text-sm leading-relaxed text-ink/80" data-id="element-294" data-mp="198kmshfpqi36">{children}</p>
      </div>
    </li>;
}